// utils/socket.js
import { io } from "socket.io-client";
import { BASE_URL } from "./api_base_url_configration";

// socket.io runs on the same server as the API — derive the origin instead of
// hardcoding a port (this used to be localhost:7000, where nothing listens)
const socket = io(String(BASE_URL || "").replace(/\/api\/?$/, ""), {
    transports: ['websocket'],
  });

export default socket;